import { useForm, SubmitHandler, FieldValues, UseFormOptions } from 'react-hook-form-6';

function useValidation<T extends FieldValues>(props?: UseFormOptions<T>) {
    const { register, handleSubmit, errors, getValues, setValue, control, setError, formState, reset } =
        useForm<T>(props);

    const submitDisabled = Object.keys(errors).length > 0;
    const errorCount = Object.keys(errors).length;

    const submit = (onSubmit: SubmitHandler<T>) => handleSubmit(onSubmit);

    return {
        register,
        errors,
        submitDisabled,
        submit,
        errorCount,
        setValue,
        control,
        getValues,
        setError,
        formState,
        reset,
    };
}

export default useValidation;
